<template>
    <base-list-with-heading-entry>
        <div class="flex-1">
            <div class="flex flex-wrap">
                <span class="text-gray-700 text-base font-bold mr-2 flex-auto">
                    <a :href="this.detailRoute()">{{ host.name }}</a>
                </span>
                <div class="px-2 py-1 text-xs rounded-full font-bold leading-tight flex items-center text-green-800 bg-green-200" v-if="host.status === 'normal'">
                    <div class="w-1 h-1 rounded-full bg-green-400"></div>
                    <span class="ml-1">Operating normal</span>
                </div>
                <div class="px-2 py-1 text-xs rounded-full font-bold leading-tight flex items-center text-yellow-800 bg-yellow-200" v-if="host.status === 'warning'">
                    <div class="w-1 h-1 rounded-full bg-yellow-400"></div>
                    <span class="ml-1">Known Problems</span>
                </div>
                <div class="px-2 py-1 text-xs rounded-full font-bold leading-tight flex items-center text-red-800 bg-red-200" v-if="host.status === 'interruption'">
                    <div class="w-1 h-1 rounded-full bg-red-400"></div>
                    <span class="ml-1">Interruption</span>
                </div>
            </div>
        </div>
    </base-list-with-heading-entry>
</template>

<script>
export default {
    props: {
        host: {
            required: true,
            type: Object,
        },
    },
    methods: {
        detailRoute() {
            console.log(this.host);
            return route('host', {
                hostID: this.host.id
            });
        },
    }
}
</script>
